import { Component, OnInit } from '@angular/core';
import { StepDescription } from '../../models/intefaces/step-description';
import { OrderingProcessService } from '../../services/ordering-process/ordering-process.service';
import { IntroductionStep } from '../../models/steps/introduction-step';

@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss'],
})
export class IntroductionComponent implements OnInit {
  stepsDescription: StepDescription[] = [];

  constructor(
    private readonly orderingProcessService: OrderingProcessService
  ) {}

  ngOnInit(): void {
    const step = this.orderingProcessService.getCurrentStep<IntroductionStep>();
    this.stepsDescription = step.descriptions;
    step.setReady();
  }
}
